<template>
    <validation-observer
        v-slot="{ invalid }"
        tag="div"
        class="home scrollbar-container"
        v-if="wxCode"
    >
        <!-- 这种写法和结构是为了避免键盘弹出时布局改变导致界面不美观 -->
        <div class="logImg-container">
            <div class="logImg bg-contain"></div>
        </div>
        <div class="title">
            <div class="fz_48">Hello</div>
            <div class="fz_46">Welcome Back</div>
            <div class="login">
                <validation-provider
                    ref="mobile"
                    rules="required|mobile"
                    name="手机号码"
                    v-slot="{ errors }"
                >
                    <van-field
                        v-model="phone"
                        keyboard="number"
                        type="tel"
                        clearable
                        maxlength="11"
                        placeholder="请输入手机号码"
                        class="border-bottom mobile-field"
                        @input="onPhoneChange"
                    >
                        <zb-warning slot="right-icon" :message="errors[0]" />
                    </van-field>
                </validation-provider>
                <validation-provider rules="required|alpha_num" name="验证码" v-slot="{ errors }">
                    <van-field
                        v-model="code"
                        clearable
                        type="tel"
                        maxlength="6"
                        placeholder="请输入验证码"
                        class="border-bottom code-field"
                    >
                        <zb-warning slot="right-icon" :message="errors[0]" />
                        <van-button
                            slot="button"
                            class="codeBtn fz_28 btn btn-submit-mini"
                            :disabled="codeDisable"
                            @click="onCodeClick"
                        >
                            <span v-show="isShowCount">获取验证码</span>
                            <span v-show="!isShowCount">{{count}} s</span>
                        </van-button>
                    </van-field>
                </validation-provider>
            </div>
            <div class="protol">
                <validation-provider :rules="{ required: { allowFalse: false } }">
                    <van-checkbox v-model="checked">
                        <div class="fz_24">
                            已阅读并同意
                            <span
                                class="c_warning"
                                @click.stop="go('DealInfo',{data:'serviceAgreement2',title:'服务协议'})"
                            >《服务协议》</span>
                        </div>
                    </van-checkbox>
                </validation-provider>
            </div>
            <van-button
                class="logBtn btn btn-submit-big"
                :disabled="invalid"
                @click="onLoginClick"
            >登&nbsp;录</van-button>
        </div>
    </validation-observer>
</template>
<script>
import {
    appGetCode,
    getCode,
    appLogin,
    login,
    getOpenid,
    loginByOpenid
} from "@/api/user";
import { setToken } from "@/utils/user";
import vueCookies from "vue-cookies";
import util from "@/utils/index";
// 发送验证码频率限制
const TIME_COUNT = 180;
export default {
    name: "UserLogin",
    data() {
        return {
            checked: false,
            phone: null,
            code: null,
            // 手机号码验证状态
            isPhoneValidation: false,
            // 验证码按钮禁用状态
            codeDisable: true,
            // // 登录按钮禁用状态
            // loginDisable: true,
            // 是否显示倒计时按钮
            isShowCount: true,
            count: "",
            timer: null,
            wxCode: "",
            wxOpenid: ""
        };
    },
    computed: {
        loginDisable() {
            return !(this.isPhoneValidation && this.code && this.checked);
        }
    },
    created() {
        // 检查Cookies中是否有code
        // 如果有则表示微信授权成功已经获取到code
        const me = this,
            state = me.$store.state;
        // console.log('当前登录状态:', me.$store.state.isLogin);
        if (state.isLogin) {
            me.loginSuccess();
            return;
        }
        let code = vueCookies.get("wxCode");
        // //console.log("code", code);
        // 检查是否微信环境
        if (state.isWeiXin && !state.isDev) {
            if (!code) {
                // 如果没有cdode
                // 检查url中是否包含code
                // 如果有则表示是从微信授权页面返回的
                code = me.getQueryString("code");
                // //console.log("code", code);
                if (!code) {
                    // 跳转微信授权页面获取code
                    const appid = process.env.VUE_APP_APPID,
                        url = encodeURIComponent(window.location.href);
                    // 微信授权成功后会跳转到当前页面,然后在url中可以获取到code
                    window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${url}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
                } else {
                    // 在Cookies中存储code
                    vueCookies.set("wxCode", code, "60s");
                    // 因为跳转到微信授权页面,并且授权成功后会再次跳转到当前页面,在路由中会有两条历史记录,为了不影响导航栏的返回效果,这里路由直接跳转到登录页面
                    const location = window.location;
                    window.location.href = `${location.origin}${location.pathname}#/UserLogin`;
                }
            } else {
                // 获取用户openid
                getOpenid({ code: code }).then((res) => {
                    // 从Cookies中清空code
                    vueCookies.set("wxCode", "");
                    me.openid = res.data;
                    // //console.log("openid", me.openid);
                    // 尝试使用openid自动登录
                    me.loginByOpenid();
                });
                me.wxCode = code;
            }
        } else {
            // 非微信环境测试
            me.wxCode = "12345";
            // 测试环境处理
            if (state.isDev) {
                if (state.isApp) {
                    me.phone = "18784012064";
                    me.codeDisable = false;
                } else {
                    me.openid = process.env.VUE_APP_OPENID;
                    me.loginByOpenid();
                }
            }
        }
    },
    methods: {
        // 根据opid登录
        loginByOpenid() {
            loginByOpenid({ openid: this.openid })
                .then((res) => {
                    this.loginSuccess(res);
                })
                .catch((res) => {});
        },
        // 获取url中的参数
        getQueryString(name) {
            const reg = `(^|&)${name}=([^&]*)(&|$)`,
                r = window.location.search.substr(1).match(reg);
            if (r != null) return unescape(r[2]);
            return null;
        },
        // 手机号码变化时
        onPhoneChange(v) {
            const me = this;
            // 延时验证
            util.debounce(function() {
                // 验证手机号码是否正确
                me.$refs.mobile.validateSilent().then((res) => {
                    const is = res.valid;
                    // 倒计时按钮默认禁用
                    let codeDisable = true;
                    // 储存手机号码验证状态
                    me.isPhoneValidation = is;
                    // // 检查登录按钮状态
                    // me.checkLogin();
                    // 如果手机号码正确并且可以显示倒计时按钮
                    if (is && me.isShowCount) {
                        codeDisable = false;
                    }
                    // 存储倒计时按钮禁用状态
                    me.codeDisable = codeDisable;
                });
            });
        },
        // 点击获取验证码
        onCodeClick() {
            const me = this;
            // 如果定时器不存在
            if (!me.timer) {
                // 倒计时显示
                me.count = TIME_COUNT;
                // 隐藏发送文字
                me.isShowCount = false;
                // 禁用按钮
                me.codeDisable = true;
                // 创建定时器
                me.timer = setInterval(() => {
                    if (me.count > 0 && me.count <= TIME_COUNT) {
                        // 倒计时
                        me.count--;
                    } else {
                        me.endTimer();
                    }
                }, 1000);
                let codeFun = getCode;
                if (me.$store.state.isApp) {
                    codeFun = appGetCode;
                }
                codeFun({
                    telephone: me.phone
                }).catch((res) => {
                    me.endTimer();
                });
            }
        },
        // 结束定时器
        endTimer() {
            // 倒计时结束
            // 显示发送文字
            const me = this;
            me.isShowCount = true;
            // 清除定时器
            clearInterval(me.timer);
            me.timer = null;
            // 校验是否启用按钮
            me.onPhoneChange();
        },
        // 点击登录按钮
        onLoginClick() {
            const me = this,
                state = me.$store.state;
            // return;
            // 测试环境处理
            if (state.isDev) {
                me.openid = process.env.VUE_APP_OPENID;
            }
            let loginFun = login,
                params = {
                    telephone: me.phone,
                    code: me.code,
                    openid: me.openid
                };
            if (state.isApp) {
                loginFun = appLogin;
                params = {
                    account: me.phone,
                    checkCode: me.code
                };
            }
            loginFun(params)
                .then((res) => {
                    // 标识为首次登录
                    me.$store.state.isFirstLogin = true;
                    me.loginSuccess(res);
                })
                .catch((res) => {});
        },
        loginSuccess(res) {
            const me = this,
                targetView = me.$store.state.targetView;
            if (me.timer) {
                // 清除定时器
                clearInterval(me.timer);
            }
            if (res) {
                // 保存h5authorization
                if (me.$store.state.isApp) {
                    setToken(res.headers.authorization);
                } else {
                    setToken(res.headers.h5authorization, me.openid);
                }
            }
            if (targetView) {
                me.backGo();
            } else {
                me.replaceGo("ShopHome");
            }
        }
    }
};
</script>
<style scoped lang="scss">
.container {
    height: 100%;
    background-color: white;
}
//手机号码
.mobile-field {
    padding: 40px 0;
}
//验证码
.code-field {
    padding: 20px 0;
}
.home {
    background-color: white;
    //这种写法和结构是为了避免键盘弹出时布局改变导致界面不美观
    .logImg-container {
        padding: 180px 115px 0 115px;
        .logImg {
            width: 350px;
            height: 154px;
            background-size: 100% 100%;
            background-image: url("~@/assets/imges/user/loginlog.png");
        }
    }
    //这种写法和结构是为了避免键盘弹出时布局改变导致界面不美观
    .title {
        background-color: white;
        padding: 0 115px 0 115px;
        margin-top: 53px;
        color: #33325c;
        line-height: 46px;
    }
    .login {
        margin-top: 174px;
        .codeBtn {
            @include border-radius(6px);
            min-width: 185px;
            height: 70px;
        }
    }
    .protol {
        padding-top: 23px;
    }
    .logBtn {
        width: 100%;
        margin-top: 180px;
    }
    .border-bottom {
        &:after {
            width: 100%;
            border-color: rgba(51, 50, 92, 0.8);
        }
    }
}
</style>
